import type { ReactNode } from 'react';

export type SidebarItem = {
  label: string;
  path: string;
  active?: boolean;
  disabled?: boolean;
  badgeKey?: string;
  icon?: ReactNode;
  activePathPrefix?: string;
  activePathExcludePrefixes?: string[];
  requiredAnyOf?: string[];
};

export type SidebarSection = {
  label: string;
  children: SidebarItem[];
};

export type SidebarGroup = {
  label: string;
  children?: SidebarItem[];
  sections?: SidebarSection[];
  badgeKey?: string;
  icon?: ReactNode;
  requiredAnyOf?: string[];
};

export function getSidebarGroupChildren(group: SidebarGroup): SidebarItem[] {
  if (group.sections?.length) {
    return group.sections.flatMap((section) => section.children);
  }
  return group.children ?? [];
}

export type SidebarEntry = SidebarItem | SidebarGroup;

export type WorkspaceSearchItem = {
  label: string;
  path: string;
  groupLabel?: string;
};

export function isSidebarGroup(entry: SidebarEntry): entry is SidebarGroup {
  const group = entry as SidebarGroup;
  return (
    (Array.isArray(group.children) && group.children.length > 0)
    || (Array.isArray(group.sections) && group.sections.length > 0)
  );
}
